import CognitoUserEdit from './abstract/CognitoUserEdit'
import AWSAPI from '../../../common/AWSAPI'
import Config from '../../../Config'

class CompanyEdit extends CognitoUserEdit {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.nameTitle = '企業名'
    this.apiUrl = Config.companyAdminApiUrl.selfUser
    this.userRoleName = '企業'
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
  }
  componentWillMount () {
    const id = AWSAPI.getCurrentUserId('companyAdmin')
    this.loadUserDetail(id)
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/company_admin/company/detail')
        break
      default:
        break
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const companyAdmin = this.state
    const detailUrl = '/company_admin/company/detail'
    switch (name) {
      case 'save':
        this.updateUser(companyAdmin, detailUrl)
        break
      case 'cancel':
        this.props.history.push(detailUrl)
        break
      default:
        break
    }
  }
}

export default CompanyEdit



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/CompanyEdit.js